module.exports = __webpack_public_path__ + "static/chat-e97dd4e452d1c7814c453171518d4f77.svg";